import React, { useEffect, useState } from 'react';
import Client from '../utils/network';
import { InitialMapImage, MapImage } from '../reducers/map/mapReducer';
import MapImageForm from '../components/MapImages/MapImageForm';
import Button from '../components/UI/Button';


const defaultStats: InitialMapImage = {
    image: '',
    xPos: 0,
    yPos: 0,
    width: 1,
    height: 1,
    yScale: 1,
    xScale: 1,
    rotation: 0,
};
const MapImageOverview = () => {
    const [mapImages, setMapImages] = useState<MapImage[]>([]);
    const [editingId, setEditingId] = useState<string>();
    const [formState, setFormState] = useState<'CREATE'|'UPDATE'>('CREATE');
    const [mapImageData, setMapImageData] = useState<InitialMapImage>(defaultStats);

    const loadMapImages = () => {
        Client.request('/api/map-image').then(async (res) => {
            const body = await res.json() as MapImage[];
            setMapImages(body);
            return;
        }).catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
        });
    };

    useEffect(() => {
        loadMapImages();
    }, []);

    const setlectMapImage = (id: string) => {
        setEditingId(id);
    };


    const onDelete = () => {
        if(!editingId) {
            return;
        }
        Client.request(`/api/map-image/${editingId}`, {
            method: 'DELETE',
        }).finally(() => {
            loadMapImages();
            createNewMapImage();
        }).catch(() => {
            // do nothing
        });
    };

    useEffect(() => {
        if(editingId) {
            Client.request(`/api/map-image/${editingId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then((res) => {
                return res.json();
            }).then((res) => {
                setMapImageData(res as MapImage);
                setFormState('UPDATE');
                return;
            }).catch((err) => {
                // eslint-disable-next-line no-console
                console.log(err);
            });
        }
    }, [editingId]);

    const onSubmit = (data: InitialMapImage) => {
        try {
            Client.request('/api/map-image', {
                method: formState === 'CREATE'
                    ? 'POST'
                    : 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    mapImage: data,
                }),
            }).then(async (res) => {
                const data = await res.json() as MapImage;
                if(formState === 'CREATE') {
                    setFormState('UPDATE');
                    setMapImageData(data);
                    setEditingId(data._id?.toString());
                }

                loadMapImages();
                return;
            }).catch((err) => {
                // eslint-disable-next-line no-console
                console.log(err);
            });

        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
        }
    };

    const createNewMapImage = () => {
        setEditingId(undefined);
        setFormState('CREATE');
        setMapImageData(defaultStats);
    };

    return (
        <div className="flex flex-row items-stretch">
            <div className='p-2 '>
                <Button
                    className={'mb-3'}
                    onClick={() => createNewMapImage()}
                >
                    Create
                </Button>
                <div className={
                    'flex flex-col overflow-y-auto overflow-x-hidden'
                    + ' pretty-scroll gap-x-8 gap-y-4 rounded-sm rounded-md'}>
                    {mapImages.map((mapImage) => (
                        <>
                            <div
                                className='block w-32 min-h-full flex'
                                key={mapImage._id?.toString()}
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                onClick={() => setlectMapImage(mapImage._id.toString())}
                            >
                                <div className='p-4 bg-mid-blue rounded-md'>
                                    <img
                                        src={`${Client.getBaseUrl()}/api/image/${mapImage.image}/thumbnail`}
                                    />
                                </div>
                            </div>
                        </>
                    ))}
                </div>
            </div>
            <div>
                <MapImageForm onSubmit={onSubmit} externalData={mapImageData} />
                {editingId && (
                    <Button onClick={onDelete}>Delete</Button>
                )}
            </div>
        </div>
    );
};

export default MapImageOverview;
